import {connect} from 'react-redux';
import CardCommissionAccountView from '../../components/views/mx/CardCommissionAccountView';
import {State} from '../../../types/mx/reducers';
import {AnyAction, Dispatch} from 'redux';
import * as ModalActions from '../../../../wizard/actions/ModalActions';
import {FormFieldProps} from '../../../../common/types/components';
import {
    CardCommissionAccountFormType, CardCommissionAccountFormDispatchProps,
    CardCommissionAccountFormStateProps
} from '../../types/mx/containers';
import * as CardCommissionAccountFormActions from '../../actions/mx/CardCommissionAccountFormActions';
import {
    CardCommissionAccountState,
    CardCommissionAccountViewFieldErrorState,
    CommissionActFile,
    CommissionCardBackupCodeFile,
    CommissionCardFileType,
    CommissionIdentificationFile,
    CommissionIdentificationGroupFile,
} from '../../types/mx/types';
import {GroupState as GeneralGroupState} from '../../types/mx/reducers';

const mapStateToProps = (state: State, ownProps): CardCommissionAccountFormStateProps => {
    const group: GeneralGroupState = state.group;
    const formType: CardCommissionAccountFormType =
        !!ownProps.data && !!ownProps.data.formType ? ownProps.data.formType :
            CardCommissionAccountFormType.CREATE_FORM_FROM_GROUP;
    const groupId: string = !!ownProps.data && !!ownProps.data.groupId ?
        ownProps.data.groupId : group.form.groupId;
    const cardCommissionAccount: CardCommissionAccountState = group.cardCommissionAccountForm;
    const cardCommissionAccountFieldError: CardCommissionAccountViewFieldErrorState =
        group.ui.cardCommissionAccountFormView.fieldErrors;
    return {
        groupId,
        formType,
        cardNumber: new FormFieldProps(
            cardCommissionAccount.cardNumber, cardCommissionAccountFieldError.cardNumberFieldError
        ),
        beneficiaryName: new FormFieldProps(cardCommissionAccount.cardHolderName,
            cardCommissionAccountFieldError.beneficiaryNameFieldError),
        owner: cardCommissionAccount.owner,
        createAt: cardCommissionAccount.createAt,
        actFile: new FormFieldProps(cardCommissionAccount.actFile,
            cardCommissionAccountFieldError.actFileFieldError),
        identificationFile: new FormFieldProps(cardCommissionAccount.identificationFile,
            cardCommissionAccountFieldError.identificationFileFieldError),
        identificationGroupFile: new FormFieldProps(cardCommissionAccount.identificationGroupFile,
            cardCommissionAccountFieldError.identificationGroupFileFieldError),
        cardBackupCodeFile: new FormFieldProps(cardCommissionAccount.cardBackupCodeFile,
            cardCommissionAccountFieldError.cardBackupCodeFileFieldError)
    };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): CardCommissionAccountFormDispatchProps => {
    return {
        onCancel: () => {
            dispatch(ModalActions.CLOSE_MODAL_ACTION.action());
        },
        onSave: (groupId: string, formType: CardCommissionAccountFormType) => {
            dispatch(CardCommissionAccountFormActions.GROUP_CARD_COMMISSION_ACCOUNT_SAVE_ACTION
                .action(groupId, formType)
            );
        },
        onChangeAccountNumber: (cardNumber: string, error: string) => {
            dispatch(CardCommissionAccountFormActions.GROUP_CHANGE_CARD_NUMBER_ACTION.action(cardNumber, error));
        },
        onChangeBeneficiary: (beneficiary: string, error: string) => {
            dispatch(CardCommissionAccountFormActions.GROUP_CHANGE_BENEFICIARY_NAME_ACTION.action(beneficiary, error));
        },
        onDropFileAct: (file: CommissionActFile, error: string) => {
            dispatch(CardCommissionAccountFormActions.GROUP_DROP_FILE_CC_ACT_ACTION.action(file, error));
        },
        onDropFileIdentification: (file: CommissionIdentificationFile, error: string) => {
            dispatch(CardCommissionAccountFormActions.GROUP_DROP_FILE_CC_IDENTIFICATION_ACTION.action(file, error));
        },
        onDropFileIdentificationGroup: (file: CommissionIdentificationGroupFile, error: string) => {
            dispatch(CardCommissionAccountFormActions.
            GROUP_DROP_FILE_CC_IDENTIFICATION_GROUP_ACTION.action(file, error));
        },
        onDropFileCardBackupCode: (file: CommissionCardBackupCodeFile, error: string) => {
            dispatch(CardCommissionAccountFormActions.
            GROUP_DROP_FILE_CC_CARD_BACKUP_CODE_ACTION.action(file, error));
        },
        onDeleteFile: (fileId: string, fileType: CommissionCardFileType, error: string) => {
            dispatch(CardCommissionAccountFormActions.
            GROUP_DELETE_FILE_CC_REQUEST_ACTION.action(fileId, fileType, error));
        }
    };
};

const CardCommissionAccountContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(CardCommissionAccountView);

export default CardCommissionAccountContainer;
